import { render, staticRenderFns } from "./CourseListPreloader.vue?vue&type=template&id=8a2abbfc&scoped=true&"
import script from "./CourseListPreloader.vue?vue&type=script&lang=js&"
export * from "./CourseListPreloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2abbfc",
  null
  
)

export default component.exports